import { render } from "./index.vue?vue&type=template&id=c6bd08c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c6bd08c6&lang=scss&scoped=true"

import exportComponent from "D:\\后台PC\\Yiwu_Commodity_WMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6bd08c6"]])

export default __exports__